import { useContext } from 'react';
import { Link } from 'react-router-dom';
import { LandingContext } from './LandingContext';
import './B2CFooter.css';
import DefaultData from "../../CompanyData/DefaultData";
const B2CFooter = () => {
    const landingData = useContext(LandingContext);
    return (
        <footer
            className="footer-container"
            style={{ backgroundColor: DefaultData?.THEMECOLOR2 || '#1a1a1a' }}
        >
            <div className="footer-content">
                {/* Column 1: Brand Info */}
                <div className="footer-column brand-info">
                    <div className="footer-brand">
                        <img src="/assets/images/logo-black.png" alt="logo" className="footer-logo" />
                    </div>
                    <p className="footer-tagline">
                        {DefaultData.FOOTERSUBTITLE}
                    </p>
                    <div className="footer-social">
                        <Link to={DefaultData?.FACEBOOKURL} target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                            <i className="ri-facebook-fill"></i>
                        </Link>
                        <Link to={DefaultData?.TWITTERURL} target="_blank" rel="noopener noreferrer" aria-label="Twitter">
                            <i className="ri-twitter-x-fill"></i>
                        </Link>
                        <Link to={DefaultData?.INSTGRAMURL} target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                            <i className="ri-instagram-fill"></i>
                        </Link>
                        <a href={DefaultData?.WHATSAPPURL} target="_blank" rel="noopener noreferrer" aria-label="WhatsApp">
                            <i className="ri-whatsapp-fill"></i>
                        </a>
                    </div>
                </div>

                {/* Column 2: Search Links */}
                <div className="footer-column">
                    <h4 className="footer-heading">Search</h4>
                    <ul className="footer-links">
                        <li><Link to="/">Home</Link></li>
                        <li><Link to="/search/flights">Flights</Link></li>
                        <li><Link to="/search/hotels">Hotels</Link></li>
                        <li><Link to="/holidays">Holidays</Link></li>
                        <li><Link to="/search/sightseeing">SightSeeing</Link></li>
                    </ul>
                </div>

                {/* Column 3: The Company */}
                <div className="footer-column">
                    <h4 className="footer-heading">The Company</h4>
                    <ul className="footer-links">
                        <li><Link to="/aboutus">About Us</Link></li>
                        <li><Link to="/terms">Terms and Conditions</Link></li>
                        <li><Link to="/faq">FAQ's</Link></li>
                        <li><Link to="/privacy-policy">Privacy Policy</Link></li>
                        <li><Link to="/refund">Refund Policy</Link></li>
                        <li><Link to="/contact-us">Contact Us</Link></li>
                    </ul>
                </div>

                {/* Column 4: Payments and Partners */}
                <div className="footer-column">
                    <h4 className="footer-heading">Payment Methods</h4>
                    <div className="payment-icons">
                        {/* Row 1 */}
                        <div className="payment-icon-wrapper">
                            <img src="/assets/images/master.png" alt="Mastercard" title="Mastercard" />
                        </div>
                        <div className="payment-icon-wrapper">
                            <img src="/assets/images/visa.png" alt="Visa" title="Visa" />
                        </div>
                        <div className="payment-icon-wrapper">
                            <img src="/assets/images/Amex.png" alt="American Express" title="American Express" />
                        </div>
                        {/* Row 2 */}
                        <div className="payment-icon-wrapper">
                            <img src="/assets/images/google.png" alt="Google Pay" title="Google Pay" />
                        </div>
                        <div className="payment-icon-wrapper">
                            <img src="/assets/images/macpay.png" alt="Apple Pay" title="Apple Pay" />
                        </div>
                        <div className="payment-icon-wrapper">
                            <img src="/assets/images/shopify.png" alt="Shopify Pay" title="Shopify Pay" />
                        </div>
                    </div>

                    <h4 className="footer-heading partners-heading">Our Partners</h4>
                    {/* Use the SAME class names as the payment methods for consistent styling */}
                    <div className="payment-icons"> {/* <-- CHANGED from partner-icons */}
                        <div className="payment-icon-wrapper"> {/* <-- CHANGED from partner-icon-wrapper */}
                            <img src="/assets/images/razorpay.png" alt="Razorpay" title="Razorpay" />
                        </div>
                        <div className="payment-icon-wrapper"> {/* <-- CHANGED from partner-icon-wrapper */}
                            <img src="/assets/images/IATA.png" alt="IATA" title="IATA" />
                        </div>
                    </div>
                </div>
            </div>

            <div className="footer-bottom">
                <p>© {DefaultData.FOOTERCOPYRIGHTS}</p>
                <ul className="footer-bottom-links">
                    <li><Link to="/terms">Terms of services</Link></li>
                    <li><Link to="/privacy-policy">Privacy Policies</Link></li>
                    <li><Link to="/faq">FAQ</Link></li>
                    <li><Link to="/refund">Refund</Link></li>
                </ul>
            </div>
        </footer>
    );
};

export default B2CFooter;
